import { DataTableBodyComponent, dataTableBodyTemplate } from './DataTableBody';
import styles from './DataTableBody.styles.scss';
export const dataTableBodyDefinition = {
    baseName: 'data-table-body',
    template: dataTableBodyTemplate,
    styles,
};
export const chameleonDataTableBody = DataTableBodyComponent.compose(dataTableBodyDefinition);
